import { Component, Input, OnInit } from '@angular/core';

const greyColors = [
  'grey-0',
  'grey-50',
  'grey-100',
  'grey-200',
  'grey-300',
  'grey-400',
  'grey-500',
  'grey-600',
  'grey-700',
  'grey-800',
  'grey',
] as const;
type greyColor = (typeof greyColors)[number];

@Component({
  selector: 'smatchy-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: false,
})
export class IconComponent implements OnInit {
  @Input() icon!: string;
  @Input() color:
    | 'default'
    | 'danger'
    | 'success'
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'white'
    | 'info'
    | greyColor
    | string = 'primary';
  @Input() size: 'default' | 'none' | 'small' | 'medium' = 'default';

  constructor() {}

  ngOnInit() {}
}
